<template>
  <div class="app-wrapper">
    <v-app class="transparent-app">

      <!-- ===== MODERN HEADER ===== -->
      <header class="modern-header">
        <div class="nav-container">
          <div class="nav-brand">
            <router-link :to="{ name: 'Index' }" class="brand-link">
              <img src="@/assets/Both/Logos/OlPejetaLogo.png"
                   alt="Ol Pejeta Conservancy"
                   class="brand-logo" />
            </router-link>
          </div>

          <div class="nav-menu desktop-menu">
            <router-link :to="{ name: 'Index' }" class="nav-link" active-class="active-link" exact-active-class="exact-active">
              <span class="nav-text">Home</span>
              <span class="nav-indicator"></span>
            </router-link>
            <router-link :to="{ name: 'SupportUs' }" class="nav-link" active-class="active-link">
              <span class="nav-text">Support Us</span>
              <span class="nav-indicator"></span>
            </router-link>
            <router-link :to="{ name: 'VolunteerProgram' }" class="nav-link" active-class="active-link">
              <span class="nav-text">Immersive Conservation Experience</span>
              <span class="nav-indicator"></span>
            </router-link>
            <router-link :to="{ name: 'RegisterMember' }" class="nav-link" active-class="active-link">
              <span class="nav-text">Become a Member</span>
              <span class="nav-indicator"></span>
            </router-link>
            <router-link :to="{ name: 'Login' }" class="nav-link login-link" active-class="active-link">
              <span class="nav-text">Login</span>
              <span class="nav-indicator"></span>
            </router-link>

            <v-menu offset-y absolute :full-width="true" v-if="local_route === true" class="currency-dropdown">
              <v-btn :depressed="true" slot="activator" flat class="currency-btn">
                <span class="earth">Currency – {{ currency }}</span>
              </v-btn>
              <v-list>
                <v-list-tile v-for="(curency, key) in allCurrencies"
                             @click="currencyChange(curency)"
                             :key="key">
                  <v-list-tile-title>{{ curency.currency_name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>

          <!-- Mobile: light single menu icon (restored) -->
          <div class="mobile-menu-toggle" @click="toggleMobileMenu">
            <v-icon class="mobile-menu-icon" light>menu</v-icon>
          </div>
        </div>

        <transition name="fade">
          <div class="mobile-overlay" v-if="mobileMenuOpen" @click="closeMobileMenu"></div>
        </transition>
        <transition name="slide-right">
          <div class="mobile-menu" v-if="mobileMenuOpen">
            <div class="mobile-menu-inner">
              <div class="mobile-menu-header">
                <img src="@/assets/Both/Logos/OlPejetaLogo.png" alt="Ol Pejeta" class="mobile-logo" />
                <button class="mobile-close-btn" @click="closeMobileMenu">✕</button>
              </div>
              <div class="mobile-nav-links">
                <router-link :to="{ name: 'Index' }" class="mobile-nav-link" @click.native="closeMobileMenu">
                  <span class="mobile-nav-icon">🏠</span> Home
                </router-link>
                <router-link :to="{ name: 'SupportUs' }" class="mobile-nav-link" @click.native="closeMobileMenu">
                  <span class="mobile-nav-icon">❤️</span> Support Us
                </router-link>
                <router-link :to="{ name: 'VolunteerProgram' }" class="mobile-nav-link" @click.native="closeMobileMenu">
                  <span class="mobile-nav-icon">🌿</span> Immersive Conservation Experience
                </router-link>
                <router-link :to="{ name: 'RegisterMember' }" class="mobile-nav-link" @click.native="closeMobileMenu">
                  <span class="mobile-nav-icon">✨</span> Become a Member
                </router-link>
                <router-link :to="{ name: 'Login' }" class="mobile-nav-link login-mobile" @click.native="closeMobileMenu">
                  <span class="mobile-nav-icon">🔑</span> Login
                </router-link>
              </div>
              <div class="mobile-currency-section" v-if="local_route === true">
                <div class="mobile-currency-title">Select Currency</div>
                <div class="mobile-currency-list">
                  <div v-for="(curency, key) in allCurrencies"
                       :key="key"
                       @click="currencyChange(curency)"
                       class="mobile-currency-option"
                       :class="{ 'active': isSelectedCurrency(curency) }">
                    <span class="currency-symbol-mobile">{{ getCurrencySymbol(curency.currency_name) }}</span>
                    {{ curency.currency_name }}
                  </div>
                </div>
              </div>
              <div class="mobile-footer-links">
                <a v-for="(link, idx) in links" :key="idx" :href="link.url" target="_blank" class="mobile-footer-link">
                  {{ link.name }}
                </a>
              </div>
            </div>
          </div>
        </transition>
      </header>
      <!-- ===== END HEADER ===== -->

      <v-content class="transparent-content">
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </v-content>
    </v-app>

    <v-footer height="auto" color="white lighten-1">
      <v-layout justify-center row wrap>
        <v-btn class="v-btn v-btn--flat theme--light primary--text" v-for="(link, idx) in links" :key="idx">
          <strong><a :href="link.url" target="_blank" id="links">{{link.name}}</a></strong>
        </v-btn>
        <v-flex white lighten-2 py-3 text-xs-center primary--text xs12>
          &copy;2023 — <strong>Ol Pejeta Conservancy</strong>
        </v-flex>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '',
      mobileMenuOpen: false,
      isScrolled: false,
      icons: [
        { 'url': '', 'icon_name': 'fa fa-facebook' },
        { 'url': '', 'icon_name': 'fa fa-twitter' },
        { 'url': '', 'icon_name': 'fa fa-google-plus' },
        { 'url': '', 'icon_name': 'fa fa-linkedin' },
        { 'url': '', 'icon_name': 'fa fa-instagram' }
      ],
      links: [
        { 'url': 'https://www.olpejetaconservancy.org/about-us/copyrights-and-credits/', 'name': 'Copyright and Credits' },
        { 'url': 'https://www.olpejetaconservancy.org/about-us/privacy-policy/', 'name': 'Privacy Policy' },
        { 'url': 'https://www.olpejetaconservancy.org/about-us/contact-us/', 'name': 'Contact Us' }
      ]
    }
  },
  computed: {
    currency: function () {
      return this.$store.state.CurrencyStore.browser_currency
    },
    allCurrencies() {
      return this.$store.state.CurrencyStore.all_currencies || []
    },
    local_route () {
      if (this.$route.meta.payment) {
        return false
      } else {
        return true
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_currencies')
    localStorage.setItem('donation', JSON.stringify([]))

    // Live Chat Integration
    window.__lc = window.__lc || {}
    window.__lc.license = 8631579
    var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true
    lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js'
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s)

    // Google Analytics Integration
    window.dataLayer = window.dataLayer || []
    lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://' + 'www.googletagmanager.com/gtag/js?id=AW-942857980')
    function gtag (){ dataLayer.push(arguments) }
    gtag('js', new Date())
    gtag('config', 'AW-942857980')

    // Facebook Pixel Integration
    !function(f,b,e,v,n,t,s) {
      if (f.fbq) return; n=f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) }
      if (!f._fbq)f._fbq = n; n.push = n; n.loaded =! 0; n.version = '2.0'
      n.queue = []; t = b.createElement(e); t.async =! 0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s) } (window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
      fbq('init', '429186911200180')
      fbq('track', 'PageView')
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    document.addEventListener('keydown', this.handleEscapeKey)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('keydown', this.handleEscapeKey)
  },
  methods: {
    navigate: function (path) {
      this.$router.push({ name: path })
    },
    getCurrencySymbol(currencyName) {
      const symbols = {
        'USD': '$', 'EUR': '€', 'GBP': '£', 'KES': 'KSh', 'CAD': 'C$',
        'AUD': 'A$', 'JPY': '¥', 'CNY': '¥', 'CHF': 'Fr', 'NZD': 'NZ$',
        'ZAR': 'R', 'INR': '₹'
      }
      return symbols[currencyName] || (currencyName && currencyName.charAt(0)) || '$'
    },
    isSelectedCurrency(currency) {
      const current = this.$store.state.CurrencyStore.browser_currency
      if (!current || !currency) return false
      const currentName = typeof current === 'object' ? current.currency_name : current
      return currentName === currency.currency_name
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : ''
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
      document.body.style.overflow = ''
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape') {
        this.closeMobileMenu()
      }
    }
  }
}
</script>

<style>
  /* ---- Fonts & base ---- */
  @font-face { font-family: Earthwerk; font-weight: bold; src: url('./../assets/Both/Fonts/Earthwerk/PizzaDude.dk - Earthwerk.otf');}
  @font-face { font-family: Akzidenz; font-weight: bold; src: url('./../assets/Both/Fonts/Akzidenz Grotesk/akzidenz-grotesk-black.ttf');}
  @font-face { font-family: Knockout; font-weight: bold; src: url('./../assets/Both/Fonts/Knockout/knockout-htf-69-full-liteweight-1361516723.ttf');}
  @import url('https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,600;14..32,700;14..32,800&family=Montserrat:wght@400;500;600;700;800&display=swap');

  .opc_green { color: #731533; }
  .opc_arial { font-family: Arial; }
  .green { background-color: #74a533; color: #ffffff; }
  .earth-color { font-family: 'Helvetica'; color: #74a533; }
  .earth { font-family: Earthwerk; }
  .akzidenz-color { font-family: Akzidenz; color: #74a533; }
  .akzidenz { font-family: Akzidenz; font-size: 36px; }
  .knockout-color { font-family: Knockout; color: #74a533; font-size: 22px; }
  a { text-decoration: none; }
  #links:hover { text-decoration: none; color: #74a533; }

  body {
    margin: 0;
    font-family: 'Inter', 'Montserrat', 'Knockout', 'Segoe UI', sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    background: #fdfbf5; /* creamy off-white */
  }

  /* ---- Force Vuetify wrappers transparent so creamy bg shows ---- */
  .transparent-app,
  .transparent-app .v-application--wrap,
  .transparent-content,
  .transparent-content .v-content__wrap {
    background: transparent !important;
  }

  /* ---- App wrapper: creamy, attractive background ---- */
  .app-wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #fdfbf5; /* soft creamy white */
  }

  .v-footer {
    background-color: transparent !important;
  }

  /* ============================================================
     MODERN HEADER — glassy green with yellow active indicator
  ============================================================ */
  .modern-header {
    position: relative;
    padding: 10px 20px;
    background: transparent;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    z-index: 100;
  }

  .nav-container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0.5rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.5rem;
    background: rgba(116, 165, 51, 0.90);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.20);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    transition: all 0.3s ease;
  }

  .brand-link { display: inline-block; transition: transform 0.4s ease; }
  .brand-link:hover { transform: scale(1.05); }

  .brand-logo {
    height: 65px;
    width: auto;
    filter: brightness(0) invert(1);
    transition: all 0.3s ease;
  }

  .desktop-menu {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  .nav-link {
    font-family: 'Montserrat', 'Knockout', 'Segoe UI', sans-serif;
    font-size: 1.15rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-decoration: none;
    padding: 0.8rem 1.5rem;
    border-radius: 60px;
    color: #ffffff;
    position: relative;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    display: inline-flex;
    align-items: center;
    gap: 8px;
    text-transform: uppercase;
    text-shadow: 0 1px 3px rgba(0,0,0,0.2);
  }

  .nav-text { position: relative; z-index: 2; }

  .nav-indicator {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 3px;
    background: #ffd966;
    border-radius: 3px;
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    transform: translateX(-50%);
  }

  .nav-link:hover .nav-indicator { width: 70%; }
  .nav-link.active-link .nav-indicator {
    width: 80%;
    background: #ffd966;
    box-shadow: 0 0 12px rgba(255, 217, 102, 0.8);
  }
  .nav-link:hover {
    background: rgba(255, 255, 255, 0.20);
    transform: translateY(-3px);
  }

  .login-link {
    background: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  .login-link:hover {
    background: #ffd966;
    color: #2c3e2b;
    border-color: transparent;
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  }

  .currency-dropdown { position: relative; margin-left: 1rem; }

  .currency-btn {
    font-family: 'Montserrat', 'Knockout', sans-serif;
    background: rgba(0, 0, 0, 0.25) !important;
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 0.7rem 1.4rem !important;
    border-radius: 60px !important;
    color: white !important;
    cursor: pointer;
    font-size: 1.1rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: all 0.2s ease;
    text-shadow: 0 1px 2px rgba(0,0,0,0.2);
    min-width: auto !important;
    height: auto !important;
  }
  .currency-btn:hover {
    background: rgba(255, 255, 255, 0.25) !important;
    transform: scale(1.02);
  }

  /* Mobile: light single menu icon */
  .mobile-menu-toggle {
    display: none;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    cursor: pointer;
    z-index: 2100;
  }

  .mobile-menu-icon {
    font-size: 28px !important;
    color: rgba(255, 255, 255, 0.85) !important;
    transition: color 0.2s ease, transform 0.2s ease;
  }

  .mobile-menu-toggle:hover .mobile-menu-icon {
    color: #ffffff !important;
    transform: scale(1.08);
  }

  .mobile-overlay {
    position: fixed; top: 0; left: 0; width: 100%; height: 100%;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    z-index: 1500;
  }

  .mobile-menu {
    position: fixed; top: 0; right: 0;
    width: 85%; max-width: 400px; height: 100vh;
    background: linear-gradient(145deg, #1e2f1a 0%, #0f1a0c 100%);
    z-index: 2000;
    box-shadow: -8px 0 30px rgba(0, 0, 0, 0.4);
    padding: 1.5rem; overflow-y: auto;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
  }

  .mobile-menu-inner { display: flex; flex-direction: column; gap: 2rem; }

  .mobile-menu-header {
    display: flex; justify-content: space-between; align-items: center;
    padding-bottom: 1rem;
    border-bottom: 2px solid rgba(116, 165, 51, 0.5);
  }

  .mobile-logo { height: 50px; filter: brightness(0) invert(1); }

  .mobile-close-btn {
    background: transparent; border: none; color: white;
    font-size: 32px; cursor: pointer; width: 44px; height: 44px;
  }

  .mobile-nav-links { display: flex; flex-direction: column; gap: 1rem; }

  .mobile-nav-link {
    font-family: 'Montserrat', 'Knockout', sans-serif;
    font-size: 1.25rem; font-weight: 600; text-decoration: none;
    color: #f0f0f0; padding: 1rem 0.8rem; border-radius: 60px;
    transition: all 0.25s; display: flex; align-items: center; gap: 14px;
  }

  .mobile-nav-icon { font-size: 1.4rem; width: 36px; }

  .mobile-nav-link:hover { background: rgba(116, 165, 51, 0.4); color: #ffd966; }

  .login-mobile { background: #74a533; margin-top: 0.5rem; justify-content: center; }

  .mobile-currency-section {
    background: rgba(255, 255, 255, 0.08);
    border-radius: 28px; padding: 1.2rem;
  }

  .mobile-currency-title {
    font-family: 'Montserrat', 'Knockout', sans-serif;
    color: #ffd966; font-size: 1.1rem; font-weight: 700; margin-bottom: 1rem;
  }

  .mobile-currency-list { display: flex; flex-direction: column; gap: 0.7rem; }

  .mobile-currency-option {
    font-family: 'Inter', 'Knockout', sans-serif;
    padding: 0.8rem; background: rgba(255, 255, 255, 0.1);
    border-radius: 50px; cursor: pointer; transition: all 0.25s;
    color: white; display: flex; align-items: center; gap: 14px; font-weight: 500;
  }
  .mobile-currency-option.active { background: #74a533; transform: translateX(5px); }

  .currency-symbol-mobile {
    background: #74a533; padding: 6px 12px; border-radius: 40px; font-weight: 800;
  }

  .mobile-footer-links {
    display: flex; flex-wrap: wrap; gap: 1rem;
    padding-top: 1rem; border-top: 1px solid rgba(255, 255, 255, 0.2);
  }
  .mobile-footer-link { font-size: 0.8rem; color: #ccc; text-decoration: none; }

  /* Transitions */
  .fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease; }
  .fade-enter, .fade-leave-to { opacity: 0; }
  .slide-right-enter-active, .slide-right-leave-active { transition: transform 0.3s ease; }
  .slide-right-enter, .slide-right-leave-to { transform: translateX(100%); }

  /* Responsive */
  @media (max-width: 968px) {
    .desktop-menu { display: none; }
    .mobile-menu-toggle { display: flex; }
    .nav-container { padding: 0.5rem 1rem; margin: 0; border-radius: 12px; }
    .modern-header { padding: 8px 12px; }
    .brand-logo { height: 52px; }
  }

  @media (max-width: 580px) {
    .brand-logo { height: 44px; }
    .mobile-menu { width: 100%; max-width: 100%; }
    .nav-container { padding: 0.4rem 0.8rem; border-radius: 10px; }
  }
</style>